import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importa los archivos de traducción para los idiomas que necesitas
import translationEn from './locales/en.json';
import translationEs from './locales/es.json';

const resources = {
  en: {
    translation: translationEn,
  },
  es: {
    translation: translationEs,
  },
};

i18n
  .use(initReactI18next) // Conecta i18n con React
  .init({
    resources,
    lng: 'es', // Idioma por defecto
    interpolation: {
      escapeValue: false, // Evita problemas con escapado de cadenas
    },
  });

export default i18n;